'use client';
import styled from 'styled-components';

export const MobileText = styled.span`
  display: initial;
  @media ${props => props.theme.tablet} {
    display: none;
  }
`;

export const DesktopText = styled.span`
  display: none;
  @media ${props => props.theme.tablet} {
    display: initial;
  }
`;
